export default __webpack_public_path__ + "static/media/Background 5_00082.fcc46607.png";